import React, { useState } from 'react';
import '../styles/Gallery.css'; // Importer le CSS global
import Modal from '../components/Modal';  // Importer le composant Modal

const Complique = () => {
  const images = [
    '/complique1.jpg',
  '/complique2.jpg',
  '/complique3.jpg',
  '/complique4.jpg',
  '/complique5.jpg',
  '/complique8.jpg',
  '/complique9.jpg',
  '/complique10.jpg',
  '/complique11.jpg',
  '/complique12.jpg',
  '/complique13.jpg',
  '/complique14.jpg',
  '/complique15.jpg',
'/affiche-complique.jpg',
    // Ajoute ici toutes les autres images
  ];

  const [modalImage, setModalImage] = useState(null);  // État pour l'image du modal
  const [modalAltText, setModalAltText] = useState("");  // État pour le texte alternatif de l'image

  const openModal = (image, altText) => {
    setModalImage(image);
    setModalAltText(altText);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalAltText("");
  };

  return (
    <div className="album-detail">
      <h1>Album Complique</h1>
      <div className="image-gallery">
        {images.map((image, index) => (
          <img
            key={index}
            src={`/album/complique/${image}`}
            alt={`Détail de l'image ${index + 1}`}  // Descriptions concises pour l'accessibilité
            className="album-image"
            onClick={() => openModal(`/album/complique/${image}`, `Détail de l'image ${index + 1}`)}  // Ouvre en grand
          />
        ))}
      </div>

      {/* Affichage du Modal lorsque l'image est cliquée */}
      {modalImage && <Modal image={modalImage} altText={modalAltText} onClose={closeModal} />}
    </div>
  );
};

export default Complique;
